module.exports = __webpack_public_path__ + "img/logo_transparent.58570cef.png";